// extracted by mini-css-extract-plugin
export default {"legend":"Loa-z","legendSpacing":"Moa-z"};